namespace $.$$ {
	export class $shm_hitalama_text_embed extends $.$shm_hitalama_text_embed {
		sub() {
			const content = super.sub()
			return content[0] === this.Image() ? [ this.Image_view() ] : content
		}
	}
}
